"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMpShopUrl = void 0;
var MP_SHOP_ENV_URL_1 = require("../env/MP_SHOP_ENV_URL");
var getMpShopUrl = function (env, mpShopUrlOverride) {
    if (mpShopUrlOverride) {
        return mpShopUrlOverride;
    }
    switch (env) {
        // If DQS and PROD the corresponding
        // enviroment url should be used
        case 'dqs':
        case 'prod': {
            return MP_SHOP_ENV_URL_1.MP_SHOP_ENV_URL[env];
        }
        // Else, use DQS as a default
        default: {
            return MP_SHOP_ENV_URL_1.MP_SHOP_ENV_URL.dqs;
        }
    }
};
exports.getMpShopUrl = getMpShopUrl;
